import * as Styles from "../styles/Main.styles";
import { useCombinedStore } from "../store";
import lastPeriodIcon from "../assets/lastPeriod.svg";
import { format, formatDistance, formatDistanceToNow } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import api from "../services/api.service";
import { ChangeEvent, useState } from "react";
import * as AlfredoComponents from "../components";
import { useParams } from "react-router-dom";
import React from "react";

interface PaymentMethod {
  paymentMethodUuid: string;
  paymentMethodType: string;
  paymentMethodName: string;
}

interface InputValue {
  paymentMethod: PaymentMethod;
  value: string;
}

interface EnteredValue {
  paymentMethod: PaymentMethod;
  value: number;
}

export default function PeriodContent() {
  const {
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setMessageZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
    };
  });
  const { saleOption } = useParams();

  const handlePDVInfoChange =
    (fieldName: string, saleOptionUuid?: string) =>
      (e: ChangeEvent<HTMLInputElement>) => {
        if (fieldName.includes("homeInfo.itemInfoValue")) {
          const updatedSelectedPDV = {
            ...subsidiaryDataZustand.selectedPdv,
            homeInfo: {
              ...subsidiaryDataZustand.selectedPdv.homeInfo,
              itemInfoValue: {
                ...subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue,
                [fieldName.replace("homeInfo.itemInfoValue.", "")]:
                  e.target.value,
              },
            },
          };
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: updatedSelectedPDV,
          });
        } else if (fieldName.includes("saleOption")) {
          const updatedSaleOptions =
            subsidiaryDataZustand.selectedPdv.saleOptions.map(
              (saleOption: any) => {
                if (saleOption.itemInfoUuid === saleOptionUuid) {
                  return {
                    ...saleOption,
                    itemInfoValue: {
                      ...saleOption.itemInfoValue,
                      [fieldName.replace("saleOption.", "")]: e.target.value,
                    },
                  };
                }
                return saleOption;
              }
            );
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: {
              ...subsidiaryDataZustand.selectedPdv,
              saleOptions: updatedSaleOptions,
            },
          });
        }
      };

  const [confirmationModalOpen, setConfirmModalOpen] = useState({
    title: "",
    description: "",
    confirmationAction: () => { },
    cancelationAction: () => { },
  });
  const [currentModalOpen, setCurrentModalOpen] = useState("");
  const lastPeriodInfo = subsidiaryDataZustand.selectedPdv.lastPeriod;
  const selectedPeriodInfo = subsidiaryDataZustand.selectedPdv.selectedPeriod;
  const periodInfo = selectedPeriodInfo || lastPeriodInfo;

  const [enteredValues, setEnteredValues] = useState<EnteredValue[]>([]);
  const [inputValues, setInputValues] = useState<InputValue[]>([]);
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null);

  const handleEnter = async (
    event: React.KeyboardEvent<HTMLInputElement>,
    paymentMethod: PaymentMethod,
    currentIndex: number,
    maxIndex: number
  ) => {
    if (event.key === 'Enter') {
      const inputValue = Number(event.currentTarget.value);
      if (inputValue > 0) {
        // Adiciona o valor digitado na lista de pagamentos registrados

        // Envia para o endpoint periodInfo
        sendPaymentToAPI(paymentMethod, inputValue);

        // Limpa o campo input atual
        setInputValues((prevValues) =>
          prevValues.map((iv) =>
            iv.paymentMethod.paymentMethodUuid === paymentMethod.paymentMethodUuid
              ? { ...iv, value: '' }
              : iv
          )
        );
        event.currentTarget.value = '';
      }
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      // Navegação com setas
      event.preventDefault();
      const newIndex =
        event.key === 'ArrowDown'
          ? currentIndex === maxIndex ? 0 : currentIndex + 1
          : currentIndex === 0 ? maxIndex : currentIndex - 1;
      setFocusedIndex(newIndex);
      const newInput = document.getElementsByName(`paymentInput_${newIndex}`)[0] as HTMLInputElement;
      if (newInput) newInput.focus();
    }
  };

  // Função para enviar pagamento para API
  // Função para enviar pagamento para API
  const sendPaymentToAPI = async (paymentMethod: any, value: number) => {
    try {
      // Verifica se já existe um pagamento para este tipo
      const existingPayment = enteredValues.find(
        (enteredValue) => enteredValue.paymentMethod.paymentMethodType === paymentMethod.paymentMethodType && paymentMethod.paymentMethodType === "cash"
      );

      if (existingPayment) {
        // Remove o pagamento existente do estado
        setEnteredValues((prevValues) =>
          prevValues.filter(
            (value) => value.paymentMethod.paymentMethodType !== paymentMethod.paymentMethodType
          )
        );

        // Exibe mensagem informando que o pagamento foi substituído
        setMessageZustand(
          `O pagamento anterior para ${paymentMethod.paymentMethodType} foi removido e substituído.`,
          `info`
        );
      }

      // Adiciona o novo pagamento ao estado e envia para a API
      setEnteredValues((prevValues) => [
        ...prevValues,
        { paymentMethod, value }
      ]);

      // Envia o novo pagamento para a API
      const paymentPeriodInfo = {
        paymentMethodUuid: paymentMethod.paymentMethodUuid,
        value,
      };
      await api.post(`/periodPayment/${periodInfo?.periodUuid}`, { paymentPeriodInfo });

      setMessageZustand(`Pagamento registrado com sucesso para ${paymentMethod.paymentMethodName}.`, `success`);
    } catch (error) {
      setMessageZustand(`Erro ao enviar pagamento.`, `error`);
    }
  };


  // Função para calcular contagens de pedidos
  const calculateOrderCounts = () => {
    const orders = periodInfo?.periodInfo?.periodOrders || [];
    const mesaOrders = orders.filter((order: any) => order.orderType === 1).length;
    const balcaoOrders = orders.filter((order: any) => order.orderType === 2).length;
    const deliveryOrders = orders.filter((order: any) => order.orderType === 3).length;
    const totalOrders = mesaOrders + balcaoOrders + deliveryOrders;

    return { mesaOrders, balcaoOrders, deliveryOrders, totalOrders };
  };

  const { mesaOrders, balcaoOrders, deliveryOrders, totalOrders } = calculateOrderCounts();

  const [expandedTypes, setExpandedTypes] = useState<Record<string, boolean>>({
    cash: false,
    card: false,
    others: false,
  });
  const paymentTypes = ['cash', 'card', 'others'];

  const toggleExpanded = (type: string) => {
    setExpandedTypes((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };
  async function handleOpenPeriod() {
    const openPeriodData = {
      item: subsidiaryDataZustand.selectedPdv.itemUuid,
      initialCashBalance: Number(
        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
          .initialCashBalance
      ),
    };

    try {
      const response = await api.post("period", openPeriodData);
      const period = response.data.period.createdPeriod;

      const periodInfoResponse = await api.get(
        `periodTypeInfo/${period.periodUuid}`
      );
      const periodInfoData =
        periodInfoResponse.data.currentPeriodTypeInfo.periodInfo;

      const periodOrders = periodInfoResponse.data.periodOrders;
      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          selectedPeriod: {
            ...period,
            periodInfo: {
              periodOrders: periodOrders,
              cashBalance:
                response.data.period.createdPeriodInfo.periodInfoValue,
              periodDiscounts: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 1
                )[0].periodTypeInfoValue
              ),
              periodTaxs: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 2
                )[0].periodTypeInfoValue
              ),
              periodProducts: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 3
                )[0].periodTypeInfoValue
              ),
              periodPayments: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 4
                )[0].periodTypeInfoValue
              ),
              periodSequence: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 5
                )[0].periodTypeInfoValue
              ),
              periodDesks: periodInfoResponse.data.currentPeriodTypeInfo.desks,
              periodCounters:
                periodInfoResponse.data.currentPeriodTypeInfo.counters,
              periodObservations: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 6
                )[0].periodTypeInfoValue
              ),
              periodDeliveryMans: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 8
                )[0].periodTypeInfoValue
              ),
              periodCancelReasons: JSON.parse(
                periodInfoData.filter(
                  (item: any) => item.periodTypeInfoType === 9
                )[0].periodTypeInfoValue
              ),
            },
          },
        },
      });
    } catch (error) {
      console.error("Error selecting file:", error);
    }
  }

  async function handleClosePeriod() {
    if (
      periodInfo?.periodInfo?.periodOrders?.filter((order: { orderStatus: number; }) => order.orderStatus < 5).length > 0) {
      //aqui, caso o periodSequence seja maior que 2, deveremos impedir que o período seja encerrado.
      if (periodInfo?.periodInfo?.periodSequence >= 2) {
        setMessageZustand("Período com contas em aberto não pode ser encerrado!", "error");
        return;
      }
      setConfirmModalOpen(
        {
          title: "Período com contas em aberto",
          description: "Confirme para enviar as contas abertas para o próximo período!",
          confirmationAction: async () => {
            try {
              ;
              const closeResponse = await api.patch(
                `period/${selectedPeriodInfo.periodUuid}/${Number(
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .initialCashBalance
                )}`
              );
              const updatedPeriod = closeResponse.data.newPeriod.createdPeriod;

              const periodInfoResponse = await api.get(
                `periodTypeInfo/${updatedPeriod.periodUuid}`
              );
              const periodInfoData =
                periodInfoResponse.data.currentPeriodTypeInfo.periodInfo;

              const periodOrders = periodInfoResponse.data.periodOrders;
              setSubsidiaryDataZustand({
                ...subsidiaryDataZustand,
                selectedPdv: {
                  lastPeriod: updatedPeriod,
                  ...subsidiaryDataZustand.selectedPdv,
                  selectedPeriod: {
                    ...updatedPeriod,
                    periodInfo: {
                      periodOrders: periodOrders,
                      cashBalance:
                        closeResponse.data.newPeriod.createdPeriodInfo.periodInfoValue,
                      periodDiscounts: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 1
                        )[0].periodTypeInfoValue
                      ),
                      periodTaxs: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 2
                        )[0].periodTypeInfoValue
                      ),
                      periodProducts: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 3
                        )[0].periodTypeInfoValue
                      ),
                      periodPayments: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 4
                        )[0].periodTypeInfoValue
                      ),
                      periodSequence: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 5
                        )[0].periodTypeInfoValue
                      ),
                      periodDesks: periodInfoResponse.data.currentPeriodTypeInfo.desks,
                      periodCounters:
                        periodInfoResponse.data.currentPeriodTypeInfo.counters,
                      periodObservations: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 6
                        )[0].periodTypeInfoValue
                      ),
                      periodDeliveryMans: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 8
                        )[0].periodTypeInfoValue
                      ),
                      periodCancelReasons: JSON.parse(
                        periodInfoData.filter(
                          (item: any) => item.periodTypeInfoType === 9
                        )[0].periodTypeInfoValue
                      ),
                    },
                  },
                },
              });
              setCurrentModalOpen("");
              setConfirmModalOpen({
                title: "",
                description: "",
                confirmationAction: () => { },
                cancelationAction: () => { },
              });
            } catch (error) {
              console.error("Error closing period:", error);
            }
          },
          cancelationAction: () => { },
        }
      );
      setCurrentModalOpen("ConfirmationModal");
      return;
    }
    try {
      let printerIp = subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.defaultPrinterAddress || "";

      const selectedSaleOption =
        subsidiaryDataZustand.selectedPdv.saleOptions.filter(
          (item) => item.itemInfoUuid === saleOption
        )[0];
      if (selectedSaleOption) {
        printerIp = selectedSaleOption.itemInfoValue.saleOptionPrinterAddress
      }
      const response = await api.patch(
        `period/${selectedPeriodInfo.periodUuid}`,
        {
          printerIp: printerIp,
        }
      );
      const updatedPeriod = response.data.updatedPeriod;

      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          selectedPeriod: null,
          lastPeriod: updatedPeriod,
        },
      });
    } catch (error) {
      console.error("Error selecting file:", error);
    }
  }

  function calcPeriodTime() {
    if (periodInfo?.periodStatus) {
      const periodTimeElapsed = formatDistanceToNow(
        new Date(periodInfo?.updatedAt),
        {
          locale: ptBR,
        }
      );

      return periodTimeElapsed;
    } else {
      const timePeriodOpend = formatDistance(
        new Date(periodInfo?.createdAt),
        new Date(periodInfo?.updatedAt),
        {
          locale: ptBR,
        }
      );

      return timePeriodOpend;
    }
  }

  return (
    <Styles.MainModalPeriodoContent>
      <AlfredoComponents.ConfirmationModal
        isOpen={currentModalOpen === "ConfirmationModal"}
        title={String(confirmationModalOpen.title)}
        description={String(confirmationModalOpen.description)}
        confirmationAction={confirmationModalOpen.confirmationAction}
        cancelationAction={confirmationModalOpen.cancelationAction}
        onRequestClose={() => {
          setCurrentModalOpen("");
          setConfirmModalOpen({
            title: "",
            description: "",
            confirmationAction: () => { },
            cancelationAction: () => { },
          });
        }}
      />
      {periodInfo ? (
        <>
          <Styles.MainModalPeriodLogo src={lastPeriodIcon} />
          <Styles.PeriodInfoContainer>
            <Styles.PeriodInfoHeader>{`Data do período: ${format(new Date(periodInfo?.updatedAt), "d 'de' LLLL 'às' HH:mm'h'", { locale: ptBR })}`}</Styles.PeriodInfoHeader>
            <Styles.PeriodInfoText><span>Período:</span>{periodInfo?.periodTypeUuid.periodTypeName}</Styles.PeriodInfoText>
            <Styles.PeriodInfoText><span>Status:</span><Styles.PeriodStatus status={periodInfo?.periodStatus ? "Aberto" : "Fechado"}>{periodInfo?.periodStatus ? "Aberto" : "Fechado"}</Styles.PeriodStatus></Styles.PeriodInfoText>
            <Styles.PeriodInfoText><span>Alterado por:</span>{`${periodInfo?.updatedByUuid.userFirstName} ${periodInfo?.updatedByUuid.userSurname}`}</Styles.PeriodInfoText>
            <Styles.PeriodInfoText><span>Tempo decorrido:</span>{calcPeriodTime()}</Styles.PeriodInfoText>
            <Styles.PeriodInfoText><span>Contas atendidas:</span>{totalOrders}</Styles.PeriodInfoText>
            <Styles.PeriodInfoText><span>Contas Mesa:</span>{mesaOrders}</Styles.PeriodInfoText>
            <Styles.PeriodInfoText><span>Contas Balcão:</span>{balcaoOrders}</Styles.PeriodInfoText>
            <Styles.PeriodInfoText><span>Contas Delivery:</span>{deliveryOrders}</Styles.PeriodInfoText>
          </Styles.PeriodInfoContainer>

          <Styles.TableContainer>
            {/* Expandable table for payment entry */}
            <Styles.ExpandableTableWrapper>
              <Styles.Table>
                <Styles.TableHeader>Forma de Pagamento</Styles.TableHeader>
                <Styles.TableHeader>Digite o Valor</Styles.TableHeader>
                <Styles.TableBody>
                  {['cash', 'card', 'others'].map((type) => {
                    const paymentMethodsOfType = subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodPayments?.PaymentMethods.filter(
                      (method: any) => method.paymentMethodType === type
                    );

                    return (
                      paymentMethodsOfType?.length > 0 && (
                        <React.Fragment key={type}>
                          <tr>
                            <Styles.TableHeader colSpan={2}>
                              <button
                                onClick={() => toggleExpanded(type)}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  color: '#007bff',
                                  fontWeight: 'bold',
                                  cursor: 'pointer',
                                }}
                              >
                                {type === 'cash' ? 'Dinheiro' : type === 'card' ? 'Cartão' : 'Outros'}
                                {expandedTypes[type] ? ' ▲' : ' ▼'}
                              </button>
                            </Styles.TableHeader>
                          </tr>
                          {expandedTypes[type] &&
                            paymentMethodsOfType.map((method: any, index: any) => (
                              <Styles.TableRow key={method.paymentMethodUuid}>
                                <Styles.TableCell>{method.paymentMethodName}</Styles.TableCell>
                                <Styles.TableCell>
                                  <input
                                    style={{ width: '100%' }}
                                    type="number"
                                    name={`paymentInput_${index}`}
                                    autoFocus={method.paymentMethodType === 'cash'}
                                    onKeyDown={(event) =>
                                      handleEnter(event, method, index, paymentMethodsOfType.length - 1)
                                    }
                                    onChange={(event: any) =>
                                      setInputValues((prevValues: any) => [
                                        ...prevValues.filter(
                                          (iv: any) => iv.paymentMethod.paymentMethodUuid !== method.paymentMethodUuid
                                        ),
                                        { paymentMethod: method, value: Number(event.target.value) }
                                      ])
                                    }
                                    value={
                                      inputValues.find(
                                        (iv) => iv.paymentMethod.paymentMethodUuid === method.paymentMethodUuid
                                      )?.value || ''
                                    }
                                  />
                                </Styles.TableCell>
                              </Styles.TableRow>
                            ))}
                        </React.Fragment>
                      )
                    );
                  })}
                </Styles.TableBody>
              </Styles.Table>
            </Styles.ExpandableTableWrapper>

            {/* Static table for payment review */}
            <Styles.TableWrapper>
              <Styles.Table>
                <Styles.TableHeader>Forma de Pagamento</Styles.TableHeader>
                <Styles.TableHeader>Total Registrado</Styles.TableHeader>
                <Styles.TableBody>
                  {['cash', 'card', 'others'].map((type) => {
                    const enteredValuesForType = enteredValues.filter(
                      (enteredValue) => enteredValue.paymentMethod.paymentMethodType === type
                    );

                    return (
                      enteredValuesForType.length > 0 && (
                        <React.Fragment key={type}>
                          {enteredValuesForType.map((enteredValue: EnteredValue, index: number) => (
                            <Styles.TableRow key={`${enteredValue.paymentMethod.paymentMethodUuid}-${index}`}>
                              <Styles.TableCell>{enteredValue.paymentMethod.paymentMethodName}</Styles.TableCell>
                              <Styles.TableCell>{enteredValue.value.toFixed(2).replace(".", ",")}
                                <Styles.TableRowRemoveButton onClick={() => setEnteredValues(
                                  enteredValues.filter((_, i) => i !== index))}>
                                  &times;
                                </Styles.TableRowRemoveButton>
                              </Styles.TableCell>
                            </Styles.TableRow>
                          ))}
                        </React.Fragment>
                      )
                    );
                  })}
                </Styles.TableBody>
              </Styles.Table>


            </Styles.TableWrapper>
          </Styles.TableContainer>
          {periodInfo?.periodStatus ? (
            <Styles.PeriodActionButton type="close" onClick={handleClosePeriod}>
              Encerrar Período
            </Styles.PeriodActionButton>
          ) : (
            <>
              {subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .askInitialCashBalance && (
                  <Styles.FieldCashContainer>
                    <Styles.NumberCashInput
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    >
                      <input
                        type="number"
                        placeholder=""
                        value={
                          subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                            .initialCashBalance
                        }
                        onChange={handlePDVInfoChange(
                          "homeInfo.itemInfoValue.initialCashBalance"
                        )}
                      />
                      <label>Fundo de Caixa:</label>
                    </Styles.NumberCashInput>
                    <Styles.UnitCash
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    >
                      R$
                    </Styles.UnitCash>
                  </Styles.FieldCashContainer>
                )}
              <Styles.PeriodActionButton type="open" onClick={handleOpenPeriod}>
                Abrir Novo Período
              </Styles.PeriodActionButton>
            </>
          )}
        </>
      ) : (
        <>
          {subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
            .askInitialCashBalance && (
              <Styles.FieldCashContainer>
                <Styles.NumberCashInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <input
                    type="number"
                    placeholder=""
                    value={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .initialCashBalance
                    }
                    onChange={handlePDVInfoChange(
                      "homeInfo.itemInfoValue.initialCashBalance"
                    )}
                  />
                  <label>Fundo de Caixa:</label>
                </Styles.NumberCashInput>
                <Styles.UnitCash
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  R$
                </Styles.UnitCash>
              </Styles.FieldCashContainer>
            )}
          <Styles.PeriodActionButton type="open" onClick={handleOpenPeriod}>
            Abrir Primeiro Período
          </Styles.PeriodActionButton>
        </>
      )}
    </Styles.MainModalPeriodoContent>
  );
}
function setExpandedTypes(arg0: (prev: any) => any) {
  throw new Error("Function not implemented.");
}

